import { gsap } from '../global/gsap';

const initFestivalMenu = (element) => {
    const body = document.querySelector('.js-body');
    const menuToggle = element.querySelectorAll('.js-menu-button');
    const navContainer = element.querySelector('.js-festival-nav-container');
    const navUpper = element.querySelector('.festival-nav__upper');
    const navItems = element.querySelectorAll('.festival-nav__container li');
    const navLower = element.querySelectorAll('.festival-nav__lower');
    const bottomItems = element.querySelectorAll('.festival-nav__lower *');
    const stopScrollingClass = 'stop-scrolling';
    const isActiveClass = 'menu-active';
    let isActive = false;

    const menuTl = gsap.timeline();

    gsap.set(navUpper, {
        y: -50,
        opacity: 0
    })

    gsap.set(navItems, {
        opacity: 0,
        y: -20
    });

    gsap.set(navLower, {
        opacity: 0,
        y: -100
    })

    gsap.set(bottomItems, {
        opacity: 0,
        y: -10
    });

    menuTl.to(navContainer, { opacity: 1, duration: 0.5 });
    menuTl.add(() => {
        if (isActive) {
            navContainer.style.pointerEvents = 'all';
        } else {
            navContainer.style.pointerEvents = 'none';
        }
    });
    menuTl.to(navUpper, {opacity: 1, y: 0, duration: .3}, '-=.3');
    menuTl.to(navItems, { opacity: 1, y: 0, stagger: 0.075, duration: 0.2 }, '-=.2');
    menuTl.to(navLower, {opacity: 1, y: 0, duration: .3}, '-=.2');
    menuTl.to(bottomItems, { opacity: 1, y: 0, stagger: 0.075, duration: 0.2 }, '-=.3');

    menuTl.pause();

    menuToggle.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            isActive = !isActive;

            if (isActive) {
                body.classList.add(stopScrollingClass, isActiveClass);
                menuTl.timeScale(1).play();
            } else {
                body.classList.remove(stopScrollingClass, isActiveClass);
                menuTl.timeScale(3).reverse();
            }
        });
    });
};

export { initFestivalMenu as default };
